"use client";

import { useTranslations } from "next-intl";
import Reveal from "../../enterprise/components/Reveal";
import { motion } from "framer-motion";

const HeroSection = () => {
  const t = useTranslations("ecosystem");
  return (
    <section className="overflow-hidden bg-gradient-to-l from-[#45A4F0] from-10% to-[#DFF3FF] ">
      <div className="flex max-lg:flex-col max-h-[430px] max-w-[1440px] mx-auto">
        <div className="ml-[78px] mt-[78px] w-[55%] text-[48px]/[56px] max-lg:ml-0 max-lg:w-full max-lg:p-4 max-lg:text-center">
        <p className="font-open-sans text-base font-normal text-[#06f]">
          Ecosystem
        </p>
        <Reveal
          delay={0.1}
          duration={0.8}
          direction="left"
          withBlur={true}
          blurAmount={8}
        >
          <h1 className="mt-8 text-[56px]/[64px] tracking-[-1px] text-[#202020] max-lg:mt-4 max-lg:text-[48px]/[56px] max-sm:text-[32px]/[40px]">
            {t("technology-beyond-limits")}
          </h1>
        </Reveal>
        <Reveal
          delay={0.5}
          duration={0.8}
          direction="left"
          withBlur={true}
          blurAmount={8}
        >
          <p className="mt-4 text-base text-[#646464]">
            {t(
              "ask-questions-share-ideas-and-participate-in-breakfasts-hubs-local-events",
            )}
          </p>
        </Reveal>
      </div>

      <motion.div
        initial={{ opacity: 0, translateY: 40 }}
        whileInView={{ opacity: 1, translateY: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
        className="w-[45%] max-lg:w-full max-lg:overflow-hidden"
      >
        {/* desktop */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="h-full w-full object-cover object-center [-webkit-mask-image:linear-gradient(to_right,transparent_0,black_15%,black_85%,transparent_100%)] *:[mask-image:linear-gradient(to_right,transparent_0,black_15%,black_85%,transparent_100%)] max-lg:hidden"
        >
          <source
            src="https://cdn-r2.hyra.network/hyra-network/eco2.webm"
            type="video/webm"
          />
        </video>
        {/* tablet - mobile */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="h-full w-full -translate-y-[40%] object-cover object-center [-webkit-mask-image:linear-gradient(to_bottom,transparent_40%,black_50%,black_80%,transparent_100%)] [mask-image:linear-gradient(to_bottom,transparent_40%,black_50%,black_80%,transparent_100%)]"
        >
          <source
            src="https://cdn-r2.hyra.network/hyra-network/eco2.webm"
            type="video/webm"
          />
        </video>
      </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
